export const mockDoctors = [
  {
    id: "siti-nurhaliza",
    name: "Dr. Siti Nurhaliza Rahman", // FEMALE
    nationality: "Malaysian-British",
    agentQuestion: "Clear Eyes - Are they infected?",
    image: "https://images.pexels.com/photos/37272329/pexels-photo-37272329.png?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Dermatologist & Psychodermatology Specialist, Project SP-ORE",
    specialization: "Psychodermatology with focus on trypophobia-related skin manifestations",
    languages: ["English (native)", "Malay (fluent)", "Mandarin (conversational)"],
    personalityTraits: [
      "Empathetic and insightful",
      "Gentle and patient listener",
      "Curious and open-minded",
      "Calm and reassuring"
    ],
    background: "Born in Kuala Lumpur, Malaysia, but moved to London at age 5. Medical degree from Imperial College London, with postgraduate specialization in psychodermatology at Kings College. Developed treatment protocols combining dermatology with cognitive behavioral therapy for Spore-affected populations.",
    focusAreas: [
      "Trypophobia-related skin conditions",
      "Psychosomatic skin disorders triggered by Spore smoke",
      "Impact of chronic stress on skin barrier function",
      "Integrated dermatology with psychological support"
    ],
    communicationStyle: "Warm, soothing, and soft-spoken with refined London accent. Slow and thoughtful pacing, uses metaphors related to mind-body connection."
  },
  {
    id: "amara-singh",
    name: "Dr. Amara Singh", // FEMALE
    nationality: "Indian-British",
    agentQuestion: "Dry Eyes - Are they infected?",
    image: "https://images.unsplash.com/photo-1659353887272-703de19bec9a?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Dermatologist & Environmental Skin Toxicologist, Project SP-ORE",
    specialization: "Effects of airborne toxins (specifically Spore smoke) on skin health",
    languages: ["English (native)", "Hindi (fluent)", "Punjabi (conversational)"],
    personalityTraits: [
      "Compassionate and nurturing",
      "Scientifically rigorous",
      "Calm and reassuring",
      "Detail-oriented with practical advice"
    ],
    background: "Born in Delhi, India, but raised in Birmingham from age 8. Medical degree from University of Birmingham, postgraduate specialization in dermatotoxicology at Oxford. Extensive research on air pollution-induced dermatitis and chemical sensitivities.",
    focusAreas: [
      "Dermatitis caused by airborne toxins",
      "Chronic inflammation and barrier dysfunction",
      "Protective skincare regimens for confined environments",
      "Effects of prolonged toxin exposure on skin aging"
    ],
    communicationStyle: "Warm, clear, and soothing with refined Birmingham accent. Moderate pace, patient and deliberate. Uses metaphors related to skin as barrier or garden."
  },
  {
    id: "timur-bekmuratov",
    name: "Dr. Timur Bekmuratov", // MALE
    nationality: "Kazakh-British",
    agentQuestion: "Eye Bleeding - Are they infected?",
    image: "https://images.unsplash.com/photo-1612531385446-f7e6d131e1d0?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Ocular Hemodynamics Specialist, Project SP-ORE",
    specialization: "Study and treatment of bloodshot eyes, ocular blood flow dynamics",
    languages: ["English (native)", "Russian (fluent)", "Kazakh (conversational)"],
    personalityTraits: [
      "Calm and composed with stoic demeanor",
      "Highly observant and detail-oriented",
      "Traditional yet open to modern methods",
      "Deep connection to nature and analogies"
    ],
    background: "Born on the Kazakh Steppe, but moved to Scotland at age 10. Medical education at University of Edinburgh, specialized in ophthalmology and vascular medicine at Glasgow. Worked extensively in high-altitude clinics before joining Project SP-ORE.",
    focusAreas: [
      "Bloodshot eyes caused by vascular irritation",
      "Vascular inflammation impact on vision",
      "Systemic circulation and ocular health relationship",
      "Managing ocular bleeding in isolated conditions"
    ],
    communicationStyle: "Deep, steady voice with Scottish-influenced accent. Measured and deliberate speech, uses earthy metaphors from highland environment."
  },
  {
    id: "callum-fraser",
    name: "Dr. Callum Fraser", // MALE
    nationality: "Scottish",
    agentQuestion: "Tired Eyes - Are they infected?",
    image: "https://images.unsplash.com/photo-1612523138351-4643808db8f3?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Senior Ophthalmic Infectious Disease Specialist, Project SP-ORE",
    specialization: "Ocular infections, fungal and microbial growth in and around the eyes",
    languages: ["English (native)", "Scottish Gaelic (fluent)"],
    personalityTraits: [
      "Meticulous and methodical",
      "Dry wit with Scottish humor",
      "Pragmatic and straightforward",
      "Patient and thorough educator"
    ],
    background: "Born and raised in Edinburgh, Scotland. Graduated from University of Edinburgh Medical School with specialization in medical mycology. Pioneer in antifungal treatment protocols adapted for subterranean environments.",
    focusAreas: [
      "Fungal infections such as fungal keratitis",
      "Secondary bacterial infections complicating fungal growth",
      "Environmental factors aiding fungal proliferation underground",
      "Infection control and quarantine procedures"
    ],
    communicationStyle: "Rich Scottish accent, warm but firm. Deliberate and steady pacing with occasional Scottish idioms."
  },
  {
    id: "lina-orantes",
    name: "Dr. Lina Orantes", // FEMALE
    nationality: "Colombian-British",
    agentQuestion: "Normal Skin - Are they infected?",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Visual Cognition & Trauma Specialist, Project SP-ORE",
    specialization: "Neuro-ophthalmology, visual hallucination mapping, stress-induced vision degradation",
    languages: ["English (native)", "Spanish (fluent)", "French (conversational)"],
    personalityTraits: [
      "Warm and empathetic",
      "Patient listener and calming presence",
      "Deeply analytical",
      "Uses vivid metaphors for complex processes"
    ],
    background: "Born in Medellín, Colombia, but moved to Manchester at age 6. Medical degree from University of Manchester, postgraduate in Neuro-Ophthalmology at UCL. Former researcher on combat veterans' PTSD-linked vision issues.",
    focusAreas: [
      "Long-term vision changes linked to chronic stress",
      "Visual hallucinations as neurological symptoms",
      "Sensory processing disorders in confined environments",
      "Integration of mental health and ophthalmology"
    ],
    communicationStyle: "Soft, melodic with refined Manchester accent. Calm and soothing, moderate pace with frequent pauses for understanding."
  },
  {
    id: "amaka-ezeobi",
    name: "Dr. Amaka Ezeobi", // FEMALE
    nationality: "Nigerian-British", 
    agentQuestion: "Freckles - Are they infected?",
    image: "https://images.pexels.com/photos/7578810/pexels-photo-7578810.jpeg?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Lead Containment Strategist & Medical Officer, Project SP-ORE",
    specialization: "Infectious disease control, outbreak response, pathogen containment",
    languages: ["English (native)", "Igbo (fluent)"],
    personalityTraits: [
      "Calm under pressure",
      "Deeply empathetic but highly analytical",
      "Unshakably rational",
      "Quietly courageous"
    ],
    background: "Nigerian, from Enugu, but educated in London from age 12. Medical degree from Imperial College London, PhD in Virology from London School of Hygiene & Tropical Medicine. Led outbreak response teams for various international incidents.",
    focusAreas: [
      "Infectious diseases and contamination control",
      "Detailed knowledge of The Spore spread patterns",
      "Psychological health during long-term confinement", 
      "Bunker systems and emergency protocols"
    ],
    communicationStyle: "Low and warm voice like calm lecturer. Refined London accent with occasional Nigerian inflections. Deliberate and measured pacing."
  },
  {
    id: "james-harrington",
    name: "Dr. James Harrington", // MALE
    nationality: "British",
    agentQuestion: "Sunburn - Are they infected?",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Dermatologist specializing in environmental skin reactions and chronic skin conditions",
    specialization: "Environmental skin reactions and chronic dermatological diseases",
    languages: ["English (native)"],
    personalityTraits: [
      "Pragmatic and thorough",
      "Approachable demeanor",
      "Expert in skin inflammation",
      "Professional yet warm"
    ],
    background: "Born and raised in London. Medical degree from University College London, specialized in environmental dermatology at Cambridge. Expert in skin inflammation, eczema, and environmental triggers.",
    focusAreas: [
      "Effects of environmental factors on skin health",
      "Chronic skin conditions management", 
      "Environmental trigger identification",
      "UV exposure and radiation skin damage"
    ],
    communicationStyle: "Clear, friendly, formal London accent. Steady and thoughtful pacing with technical but accessible vocabulary."
  },
  {
    id: "eleanor-whitaker", 
    name: "Dr. Eleanor Whitaker", // FEMALE
    nationality: "Australian-British",
    agentQuestion: "Dry Skin - Are they infected?",
    image: "https://images.unsplash.com/photo-1758685848602-09e52ef9c7d3?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Dermatologist specializing in autoimmune skin disorders and their environmental triggers",
    specialization: "Autoimmune skin diseases such as psoriasis and lupus, with focus on environmental and stress-related triggers",
    languages: ["English (native)", "Australian English"],
    personalityTraits: [
      "Compassionate and meticulous",
      "Patient with chronic conditions",
      "Extensive autoimmune experience", 
      "Supportive and encouraging"
    ],
    background: "Born in Sydney, Australia, but moved to Leeds at age 14. Medical degree from University of Leeds, specialized in autoimmune dermatology at Royal Free Hospital London. Extensive experience in chronic autoimmune skin disorders.",
    focusAreas: [
      "Autoimmune skin conditions management",
      "Environmental stress impact on flare-ups",
      "Psoriasis and lupus treatment",
      "Dry skin barrier dysfunction"
    ],
    communicationStyle: "Warm, calm with subtle Australian inflections in refined English accent. Measured and reassuring pacing."
  },
  {
    id: "mei-ling-chen",
    name: "Dr. Mei-Ling Chen", // FEMALE
    nationality: "Taiwanese-British",
    agentQuestion: "Minor Cuts - Are they infected?",
    image: "https://images.unsplash.com/photo-1618053448748-b7251851d014?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Dermatologist specializing in allergic and inflammatory skin conditions",
    specialization: "Allergic dermatitis, eczema, and skin reactions linked to environmental allergens and pollutants",
    languages: ["English (native)", "Mandarin (fluent)"],
    personalityTraits: [
      "Patient and analytical",
      "Compassionate bedside manner",
      "Skilled in wound assessment",
      "Gentle and encouraging"
    ],
    background: "Born in Taipei, Taiwan, but raised in Liverpool from age 7. Medical degree from University of Liverpool, specialized in allergic dermatology and wound care at St. Bartholomew's Hospital London.",
    focusAreas: [
      "Minor wound assessment and infection detection",
      "Allergic and inflammatory skin conditions",
      "Environmental allergen reactions",
      "Skin barrier function restoration"
    ],
    communicationStyle: "Soft, calm with clear Liverpudlian accent. Slow, thoughtful, and deliberate pacing."
  },
  {
    id: "rajiv-malhotra",
    name: "Dr. Rajiv Malhotra", // MALE
    nationality: "Indian-British",
    agentQuestion: "Skin Rash - Are they infected?",
    image: "https://images.unsplash.com/photo-1637059824899-a441006a6875?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Dermatologist specializing in pigmentary disorders and skin reactions to environmental toxins",
    specialization: "Vitiligo, melasma, and skin discolorations related to environmental exposures and toxins",
    languages: ["English (native)", "Hindi (fluent)"],
    personalityTraits: [
      "Analytical and empathetic",
      "Precise in diagnosis",
      "Expert in skin inflammation",
      "Professional and patient"
    ],
    background: "Born in Mumbai, India, but moved to Bristol at age 9. Medical degree from University of Bristol, specialized in dermatological toxicology at King's College London. Expert in diagnosing and treating inflammatory skin conditions.",
    focusAreas: [
      "Skin rash assessment and classification",
      "Pigmentary skin disorders",
      "Environmental toxin impact on skin",
      "Inflammatory dermatological conditions"
    ],
    communicationStyle: "Clear, calm with refined West Country accent. Measured and deliberate pacing."
  },
  {
    id: "sofia-alvarez",
    name: "Dr. Sofia Alvarez", // FEMALE
    nationality: "Peruvian-British",
    agentQuestion: "Bruises - Are they infected?",
    image: "https://images.unsplash.com/photo-1706565029539-d09af5896340?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Dermatologist specializing in chronic inflammatory skin diseases and trauma assessment",
    specialization: "Chronic inflammatory conditions, trauma-related skin damage, and psychosomatic effects on skin health",
    languages: ["English (native)", "Spanish (fluent)"],
    personalityTraits: [
      "Empathetic and insightful",
      "Calm under pressure",
      "Expert in trauma assessment",
      "Supportive and patient"
    ],
    background: "Born in Lima, Peru, but moved to Sheffield at age 11. Medical degree from University of Sheffield, specialized in trauma dermatology and forensic medicine at Guy's Hospital London.",
    focusAreas: [
      "Bruise assessment and differential diagnosis",
      "Chronic inflammatory skin diseases",
      "Trauma-related skin damage evaluation",
      "Psychosomatic skin health connections"
    ],
    communicationStyle: "Warm, gentle with Yorkshire-influenced accent. Calm and steady pacing."
  },
  {
    id: "hannah-oconnell",
    name: "Dr. Hannah O'Connell", // FEMALE
    nationality: "Irish-British",
    agentQuestion: "Necrosis - Are they infected?",
    image: "https://images.unsplash.com/photo-1699899657680-421c2c2d5064?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Dermatologist specializing in fungal and bacterial skin infections, advanced tissue pathology",
    specialization: "Diagnosis and treatment of fungal and bacterial infections affecting the skin, with emphasis on tissue death assessment",
    languages: ["English (native)", "Irish Gaelic (fluent)"],
    personalityTraits: [
      "Compassionate yet decisive",
      "Detail-oriented and thorough",
      "Expert in severe conditions",
      "Calm in crisis situations"
    ],
    background: "Born in Dublin, Ireland, but educated in Newcastle from age 16. Medical degree from Newcastle University, specialized in infectious diseases and tissue pathology at Royal Victoria Infirmary.",
    focusAreas: [
      "Tissue death and necrosis assessment",
      "Fungal and bacterial skin infections",
      "Advanced pathological skin conditions",
      "Critical infection control protocols"
    ],
    communicationStyle: "Clear, friendly with soft Irish-Geordie accent. Steady and reassuring pacing."
  },
  {
    id: "marcus-wright",
    name: "Dr. Marcus Wright", // MALE
    nationality: "Welsh-British",
    agentQuestion: "Normal Breathing - Are they infected?",
    image: "https://images.unsplash.com/photo-1650091903029-fc3f1ddcb7f9?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Respiratory Specialist & Pulmonologist, Project SP-ORE",
    specialization: "Pulmonary function assessment, respiratory infection detection, atmospheric contamination analysis",
    languages: ["English (native)", "Welsh (fluent)"],
    personalityTraits: [
      "Methodical and observant",
      "Calm and reassuring",
      "Expert in subtle symptoms",
      "Patient and thorough"
    ],
    background: "Born in Cardiff, Wales. Medical degree from Cardiff University, specialized in respiratory medicine at Royal Brompton Hospital London. Expert in detecting early respiratory anomalies.",
    focusAreas: [
      "Normal breathing pattern analysis",
      "Early respiratory infection detection",
      "Atmospheric contamination assessment",
      "Pulmonary function evaluation"
    ],
    communicationStyle: "Warm Welsh accent, clear and measured. Patient pacing with technical expertise."
  },
  {
    id: "david-mccallum",
    name: "Dr. David McCallum", // MALE
    nationality: "Scottish-British",
    agentQuestion: "Light Snoring - Are they infected?",
    image: "https://images.unsplash.com/photo-1686063165043-45243dab25ab?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Sleep Medicine Specialist & Respiratory Surveillance Officer, Project SP-ORE",
    specialization: "Sleep disorders, respiratory surveillance, auditory detection of breathing anomalies",
    languages: ["English (native)", "Scottish Gaelic (conversational)"],
    personalityTraits: [
      "Observant and detail-focused",
      "Patient listener",
      "Expert in subtle audio cues",
      "Calm and methodical"
    ],
    background: "Born in Glasgow, Scotland. Medical degree from University of Glasgow, specialized in sleep medicine at Royal Infirmary Edinburgh. Expert in identifying abnormal breathing patterns during sleep.",
    focusAreas: [
      "Sleep-related breathing patterns",
      "Auditory respiratory anomaly detection",
      "Sleep disorder assessment",
      "Nocturnal infection surveillance"
    ],
    communicationStyle: "Rich Glasgow accent, friendly and approachable. Deliberate pacing with good humor."
  },
  {
    id: "priya-patel",
    name: "Dr. Priya Patel", // FEMALE
    nationality: "Indian-British",
    agentQuestion: "Seasonal Sniffles - Are they infected?",
    image: "https://images.unsplash.com/photo-1659353888906-adb3e0041693?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Immunology & Environmental Pathology Specialist, Project SP-ORE",
    specialization: "Allergic reactions, seasonal symptoms, immune response assessment in confined environments",
    languages: ["English (native)", "Gujarati (fluent)", "Hindi (fluent)"],
    personalityTraits: [
      "Warm and reassuring",
      "Analytical and thorough",
      "Expert in differential diagnosis",
      "Patient and empathetic"
    ],
    background: "Born in Leicester to Indian parents. Medical degree from University of Leicester, specialized in immunology and allergy medicine at Guy's Hospital London. Expert in distinguishing allergic reactions from infections.",
    focusAreas: [
      "Seasonal allergy assessment",
      "Immune response evaluation", 
      "Allergic vs infectious symptom differentiation",
      "Environmental allergen identification"
    ],
    communicationStyle: "Clear Leicester accent with warm, patient delivery. Methodical and reassuring pacing."
  },
  {
    id: "robert-jenkins",
    name: "Dr. Robert Jenkins", // MALE
    nationality: "Welsh-British",
    agentQuestion: "Hiccuping - Are they infected?",
    image: "https://images.unsplash.com/photo-1657551856874-d492ef8ecba0?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Neurological Respiratory Specialist, Project SP-ORE",
    specialization: "Diaphragmatic disorders, neurological breathing irregularities, persistent hiccup assessment",
    languages: ["English (native)", "Welsh (fluent)"],
    personalityTraits: [
      "Precise and methodical",
      "Calm under pressure",
      "Expert in neurological symptoms",
      "Patient and thorough"
    ],
    background: "Born in Swansea, Wales. Medical degree from Swansea University, specialized in neurological respiratory disorders at National Hospital for Neurology, London.",
    focusAreas: [
      "Persistent hiccup evaluation",
      "Diaphragmatic function assessment",
      "Neurological breathing irregularities",
      "Respiratory reflex pattern analysis"
    ],
    communicationStyle: "Clear Welsh accent, measured and professional. Deliberate pacing with technical precision."
  },
  {
    id: "sarah-thompson",
    name: "Dr. Sarah Thompson", // FEMALE
    nationality: "Northern Irish-British", 
    agentQuestion: "Persistent Cough - Are they infected?",
    image: "https://images.unsplash.com/photo-1673865641073-4479f93a7776?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Pulmonary Infection Specialist, Project SP-ORE",
    specialization: "Chronic cough assessment, respiratory infection detection, pulmonary contamination analysis",
    languages: ["English (native)", "Ulster Scots (conversational)"],
    personalityTraits: [
      "Direct and thorough",
      "Compassionate but realistic",
      "Expert in persistent symptoms",
      "Methodical and precise"
    ],
    background: "Born in Belfast, Northern Ireland. Medical degree from Queen's University Belfast, specialized in pulmonary medicine at Royal Victoria Hospital. Expert in chronic respiratory conditions.",
    focusAreas: [
      "Persistent cough evaluation",
      "Chronic respiratory infection detection",
      "Pulmonary contamination assessment",
      "Long-term respiratory symptom analysis"
    ],
    communicationStyle: "Clear Northern Irish accent, direct and professional. Steady, reassuring pacing."
  },
  {
    id: "michael-davies",
    name: "Dr. Michael Davies", // MALE
    nationality: "Welsh-British",
    agentQuestion: "Bloody Cough - Are they infected?",
    image: "https://images.unsplash.com/photo-1582750433449-648ed127bb54?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Emergency Pulmonary Specialist, Project SP-ORE",
    specialization: "Hemoptysis assessment, acute respiratory emergencies, critical pulmonary infections",
    languages: ["English (native)", "Welsh (fluent)"],
    personalityTraits: [
      "Calm in emergencies",
      "Decisive and thorough",
      "Expert in critical symptoms",
      "Reassuring under pressure"
    ],
    background: "Born in Bangor, Wales. Medical degree from Bangor University, specialized in emergency pulmonary medicine at University Hospital Wales, Cardiff. Expert in acute respiratory emergencies.",
    focusAreas: [
      "Hemoptysis (bloody cough) assessment",
      "Acute respiratory emergency management",
      "Critical pulmonary infection detection",
      "Emergency containment protocols"
    ],
    communicationStyle: "Strong Welsh accent, calm and authoritative. Quick but thorough pacing in emergencies."
  },
  {
    id: "elizabeth-harper",
    name: "Dr. Elizabeth Harper", // FEMALE
    nationality: "English-British",
    agentQuestion: "Normal Temperature - Are they infected?",
    image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Internal Medicine & Vitals Specialist, Project SP-ORE",
    specialization: "Temperature regulation assessment, fever detection, vital sign interpretation",
    languages: ["English (native)"],
    personalityTraits: [
      "Methodical and precise",
      "Calm and reassuring",
      "Expert in subtle changes",
      "Thorough and patient"
    ],
    background: "Born in Cambridge, England. Medical degree from Cambridge University, specialized in internal medicine at Addenbrooke's Hospital. Expert in detecting early vital sign anomalies.",
    focusAreas: [
      "Normal temperature range assessment",
      "Early fever detection protocols",
      "Vital sign pattern analysis",
      "Thermoregulation disorders"
    ],
    communicationStyle: "Refined Cambridge accent, clear and measured. Professional pacing with attention to detail."
  },
  {
    id: "andrew-mitchell",
    name: "Dr. Andrew Mitchell", // MALE
    nationality: "Scottish-British",
    agentQuestion: "Normal Pulse - Are they infected?",
    image: "https://images.pexels.com/photos/8442615/pexels-photo-8442615.jpeg?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Cardiac Assessment Specialist, Project SP-ORE",
    specialization: "Pulse evaluation, cardiac rhythm analysis, cardiovascular infection detection",
    languages: ["English (native)", "Scottish Gaelic (conversational)"],
    personalityTraits: [
      "Calm and methodical",
      "Expert in cardiac signs",
      "Reassuring presence",
      "Detail-oriented approach"
    ],
    background: "Born in Aberdeen, Scotland. Medical degree from University of Aberdeen, specialized in cardiology at Royal Infirmary of Edinburgh. Expert in cardiac infection indicators.",
    focusAreas: [
      "Normal pulse pattern evaluation",
      "Cardiac rhythm irregularity detection",
      "Cardiovascular infection assessment",
      "Heart rate variability analysis"
    ],
    communicationStyle: "Clear Aberdeen accent, steady and reassuring. Methodical pacing with cardiac expertise."
  },
  {
    id: "claire-watson",
    name: "Dr. Claire Watson", // FEMALE
    nationality: "Northern Irish-British",
    agentQuestion: "Low Resting Pulse - Are they infected?", 
    image: "https://images.pexels.com/photos/5207104/pexels-photo-5207104.jpeg?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Sports Medicine & Cardiac Specialist, Project SP-ORE", 
    specialization: "Athletic heart assessment, bradycardia evaluation, fitness-related cardiac patterns",
    languages: ["English (native)", "Ulster Scots (conversational)"],
    personalityTraits: [
      "Encouraging and supportive",
      "Expert in athletic physiology",
      "Thorough in assessment",
      "Positive and reassuring"
    ],
    background: "Born in Derry, Northern Ireland. Medical degree from Queen's University Belfast, specialized in sports medicine and cardiology at Ulster Hospital. Expert in athletic heart conditions.",
    focusAreas: [
      "Low resting heart rate assessment",
      "Athletic heart pattern evaluation",
      "Fitness-related bradycardia",
      "Cardiovascular fitness indicators"
    ],
    communicationStyle: "Warm Northern Irish accent, encouraging and supportive. Patient pacing with sports medicine expertise."
  },
  {
    id: "thomas-brown",
    name: "Dr. Thomas Brown", // MALE
    nationality: "English-British", 
    agentQuestion: "Elevated Temperature - Are they infected?",
    image: "https://images.pexels.com/photos/8442607/pexels-photo-8442607.jpeg?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Emergency Medicine & Fever Specialist, Project SP-ORE",
    specialization: "Fever assessment, infectious disease detection, emergency temperature management",
    languages: ["English (native)"],
    personalityTraits: [
      "Calm under pressure",
      "Decisive and thorough",
      "Expert in emergency signs",
      "Reassuring but direct"
    ],
    background: "Born in Manchester, England. Medical degree from University of Manchester, specialized in emergency medicine at Manchester Royal Infirmary. Expert in fever-related infections.",
    focusAreas: [
      "Elevated temperature assessment",
      "Infectious fever detection",
      "Emergency temperature management",
      "Fever pattern analysis"
    ],
    communicationStyle: "Clear Manchester accent, direct and professional. Urgent but reassuring pacing."
  },
  {
    id: "victoria-scott",
    name: "Dr. Victoria Scott", // FEMALE
    nationality: "Scottish-British",
    agentQuestion: "Critical Fever - Are they infected?",
    image: "https://images.unsplash.com/photo-1573497161161-c3e73707e25c?crop=faces&fit=crop&w=800&h=600&q=80", 
    currentRole: "Critical Care & Infectious Disease Specialist, Project SP-ORE",
    specialization: "Critical temperature management, severe infection assessment, emergency containment",
    languages: ["English (native)", "Scottish Gaelic (fluent)"],
    personalityTraits: [
      "Calm in crisis situations",
      "Decisive and expert",
      "Thorough in emergency care",
      "Professional and direct"
    ],
    background: "Born in Inverness, Scotland. Medical degree from University of St Andrews, specialized in critical care medicine at Royal Infirmary of Edinburgh. Expert in critical infectious conditions.",
    focusAreas: [
      "Critical fever management",
      "Severe infection assessment", 
      "Emergency containment protocols",
      "Life-threatening temperature conditions"
    ],
    communicationStyle: "Highland Scottish accent, calm and authoritative. Quick decision-making with clear communication."
  },
  {
    id: "benjamin-clark",
    name: "Dr. Benjamin Clark", // MALE
    nationality: "Welsh-British",
    agentQuestion: "Fresh Breath - Are they infected?",
    image: "https://images.unsplash.com/photo-1588178454780-441fa5b99fa5?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Oral Health & Respiratory Assessment Specialist, Project SP-ORE",
    specialization: "Oral hygiene evaluation, breath analysis, respiratory infection indicators",
    languages: ["English (native)", "Welsh (fluent)"],
    personalityTraits: [
      "Detail-oriented and thorough",
      "Professional and reassuring",
      "Expert in oral health signs",
      "Patient and methodical"
    ],
    background: "Born in Cardiff, Wales. Dental degree from Cardiff University, medical degree from University of Wales. Specialized in oral-respiratory health connections at Cardiff University Hospital.",
    focusAreas: [
      "Normal breath assessment",
      "Oral hygiene evaluation",
      "Respiratory health indicators",
      "Infection-related breath changes"
    ],
    communicationStyle: "Clear Cardiff accent, professional and methodical. Thorough pacing with oral health expertise."
  },
  {
    id: "lucy-adams",
    name: "Dr. Lucy Adams", // FEMALE
    nationality: "English-British", 
    agentQuestion: "Coffee Breath - Are they infected?",
    image: "https://images.unsplash.com/photo-1627161683077-e34782c24d81?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Digestive Health & Oral Assessment Specialist, Project SP-ORE",
    specialization: "Digestive health indicators, dietary assessment, oral-systemic health connections",
    languages: ["English (native)"],
    personalityTraits: [
      "Friendly and approachable",
      "Thorough in assessment",
      "Expert in dietary health",
      "Reassuring and patient"
    ],
    background: "Born in Bath, England. Medical degree from University of Bath, specialized in gastroenterology and oral medicine at Royal United Hospital Bath. Expert in dietary-health connections.",
    focusAreas: [
      "Dietary breath assessment",
      "Digestive health evaluation",
      "Oral-systemic health connections",
      "Normal dietary indicators"
    ],
    communicationStyle: "Warm West Country accent, friendly and reassuring. Patient pacing with digestive health expertise."
  },
  {
    id: "daniel-hughes",
    name: "Dr. Daniel Hughes", // MALE
    nationality: "Welsh-British",
    agentQuestion: "Garlic Breath - Are they infected?", 
    image: "https://images.unsplash.com/photo-1712215544003-af10130f8eb3?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Nutritional Health & Oral Assessment Specialist, Project SP-ORE",
    specialization: "Nutritional assessment, food-related health indicators, oral health evaluation",
    languages: ["English (native)", "Welsh (fluent)"],
    personalityTraits: [
      "Patient and understanding",
      "Expert in nutritional health", 
      "Thorough and reassuring",
      "Professional and calm"
    ],
    background: "Born in Wrexham, Wales. Medical degree from Bangor University, specialized in nutritional medicine and oral health at Wrexham Maelor Hospital. Expert in food-health relationships.",
    focusAreas: [
      "Food-related breath assessment",
      "Nutritional health evaluation",
      "Dietary indicator analysis",
      "Normal food response patterns"
    ],
    communicationStyle: "Clear North Wales accent, patient and understanding. Thorough pacing with nutritional expertise."
  },
  {
    id: "rachel-morgan",
    name: "Dr. Rachel Morgan", // FEMALE
    nationality: "Scottish-British",
    agentQuestion: "Morning Breath - Are they infected?",
    image: "https://images.pexels.com/photos/7904457/pexels-photo-7904457.jpeg?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Sleep Medicine & Oral Health Specialist, Project SP-ORE", 
    specialization: "Sleep-related health patterns, circadian rhythm assessment, overnight health changes",
    languages: ["English (native)", "Scottish Gaelic (conversational)"],
    personalityTraits: [
      "Understanding and patient",
      "Expert in sleep patterns",
      "Thorough in evaluation",
      "Reassuring and calm"
    ],
    background: "Born in Stirling, Scotland. Medical degree from University of Stirling, specialized in sleep medicine and oral health at Forth Valley Royal Hospital. Expert in sleep-health relationships.",
    focusAreas: [
      "Morning breath evaluation",
      "Sleep-related health patterns",
      "Overnight physiological changes",
      "Circadian health indicators"
    ],
    communicationStyle: "Gentle Scottish accent, understanding and patient. Calm pacing with sleep medicine expertise."
  },
  {
    id: "jonathan-taylor",
    name: "Dr. Jonathan Taylor", // MALE
    nationality: "Northern Irish-British",
    agentQuestion: "Death-like Breath - Are they infected?",
    image: "https://images.pexels.com/photos/4270371/pexels-photo-4270371.jpeg?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Emergency Medicine & Critical Assessment Specialist, Project SP-ORE",
    specialization: "Critical health assessment, severe infection detection, emergency oral-respiratory evaluation", 
    languages: ["English (native)", "Ulster Scots (conversational)"],
    personalityTraits: [
      "Direct and professional",
      "Expert in critical signs",
      "Calm in emergencies", 
      "Thorough and decisive"
    ],
    background: "Born in Belfast, Northern Ireland. Medical degree from Queen's University Belfast, specialized in emergency medicine and critical care at Royal Victoria Hospital. Expert in critical health indicators.",
    focusAreas: [
      "Critical breath assessment",
      "Severe infection detection",
      "Emergency oral-respiratory evaluation",
      "Life-threatening health indicators"
    ],
    communicationStyle: "Direct Belfast accent, professional and decisive. Urgent but thorough pacing in critical assessments."
  },
  {
    id: "helen-edwards",
    name: "Dr. Helen Edwards", // FEMALE
    nationality: "Welsh-British",
    agentQuestion: "Alert Behavior - Are they infected?",
    image: "https://images.pexels.com/photos/8851605/pexels-photo-8851605.jpeg?auto=compress&cs=tinysrgb&w=800",
    currentRole: "Behavioral Psychology & Neurological Assessment Specialist, Project SP-ORE",
    specialization: "Behavioral pattern analysis, neurological assessment, psychological health evaluation",
    languages: ["English (native)", "Welsh (fluent)"],
    personalityTraits: [
      "Observant and analytical",
      "Expert in behavioral signs",
      "Patient and understanding",
      "Thorough in evaluation"
    ],
    background: "Born in Newport, Wales. Medical degree from Cardiff University, specialized in behavioral neurology and psychology at University Hospital of Wales. Expert in behavioral health patterns.",
    focusAreas: [
      "Normal alertness assessment",
      "Behavioral pattern evaluation",
      "Neurological health indicators",
      "Psychological alertness patterns"
    ],
    communicationStyle: "Clear Welsh accent, observant and analytical. Patient pacing with behavioral expertise."
  },
  {
    id: "peter-wilson",
    name: "Dr. Peter Wilson", // MALE
    nationality: "English-British",
    agentQuestion: "Tired Behavior - Are they infected?",
    image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Fatigue Assessment & Sleep Medicine Specialist, Project SP-ORE",
    specialization: "Fatigue evaluation, energy level assessment, sleep disorder detection",
    languages: ["English (native)"],
    personalityTraits: [
      "Understanding and patient",
      "Expert in fatigue patterns",
      "Thorough and empathetic", 
      "Calm and reassuring"
    ],
    background: "Born in Leeds, England. Medical degree from University of Leeds, specialized in sleep medicine and fatigue assessment at Leeds General Infirmary. Expert in tiredness-health relationships.",
    focusAreas: [
      "Fatigue level assessment",
      "Energy pattern evaluation",
      "Sleep disorder detection",
      "Tiredness-health connections"
    ],
    communicationStyle: "Warm Yorkshire accent, understanding and patient. Calm pacing with fatigue expertise."
  },
  {
    id: "anna-roberts",
    name: "Dr. Anna Roberts", // FEMALE
    nationality: "Northern Irish-British", 
    agentQuestion: "Anxious Behavior - Are they infected?",
    image: "https://images.unsplash.com/photo-1618053448492-2b629c2c912c?crop=faces&fit=crop&w=800&h=600&q=80",
    currentRole: "Anxiety Assessment & Behavioral Health Specialist, Project SP-ORE",
    specialization: "Anxiety evaluation, stress response assessment, psychological health in confined environments",
    languages: ["English (native)", "Ulster Scots (conversational)"],
    personalityTraits: [
      "Empathetic and calming",
      "Expert in anxiety patterns", 
      "Patient and supportive",
      "Thorough in evaluation"
    ],
    background: "Born in Armagh, Northern Ireland. Medical degree from Queen's University Belfast, specialized in psychiatry and anxiety disorders at Craigavon Area Hospital. Expert in anxiety-health relationships.",
    focusAreas: [
      "Anxiety level assessment",
      "Stress response evaluation", 
      "Psychological health patterns",
      "Confined environment mental health"
    ],
    communicationStyle: "Gentle Northern Irish accent, empathetic and calming. Supportive pacing with anxiety expertise."
  }
];